// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

import * as React from "react"
import type { GatsbyBrowser } from "gatsby"
import { LanguageProvider } from "./src/contexts/LanguageContext"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>
}
